import { useEffect } from 'react';

const countries = [
  { name: 'Halo Holidays US', flag: '/general/US.svg', url: 'https://haloholidays.us/' },
  // { name: 'Halo Holidays LK', flag: '/general/LK.svg', url: 'https://haloholidays.lk/' },
];

const CountryPopup = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  // Close the popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const popup = document.getElementById('country-popup');
      if (popup && !popup.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  return (
    <div
      className={`fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-10 ${
        isOpen ? 'block' : 'hidden'
      }`}
    >
      <div
        id="country-popup"
        className="bg-white p-6 rounded-lg w-3/4 max-w-lg"
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Please choose your Website</h2>
          <button
            onClick={onClose}
            className="text-gray-600 text-2xl hover:text-halo-pink"
          >
            x
          </button>
        </div>
        <hr className="mb-4"/>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {countries.map((country) => (
            <a
              key={country.name}
              href={country.url}
              className="flex items-center p-2 rounded transition-colors duration-300 hover:bg-halo-pink-bg hover:text-halo-pink"
              target="_blank" // Optional: opens the link in a new tab
              rel="noopener noreferrer" // Recommended for security when using target="_blank"
            >
              <img src={country.flag} alt={country.name} className="w-6 h-6 mr-2" />
              <span>{country.name}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CountryPopup;